import { useLang } from '../context/LanguageContext';
import './TrustRibbon.css';

const ITEMS = [
  {
    key: 'since',
    labelKey: 'trustSince',
    subKey: 'trustSinceSub',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M12 8v4l3 2" />
        <circle cx="12" cy="12" r="9" />
      </svg>
    ),
  },
  {
    key: 'readers',
    labelKey: 'trustReaders',
    subKey: 'trustReadersSub',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    key: 'daily',
    labelKey: 'trustDaily',
    subKey: 'trustDailySub',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2Z" />
        <path d="M8 7h8M8 11h6" />
      </svg>
    ),
  },
];

export default function TrustRibbon() {
  const { t } = useLang();

  return (
    <section className="trust-ribbon" aria-label={t.trustRibbonAria} data-sub-free>
      <div className="trust-ribbon__shell">
        <p className="trust-ribbon__eyebrow">{t.trustRibbonEyebrow}</p>
        <ul className="trust-ribbon__grid">
          {ITEMS.map((item) => (
            <li key={item.key} className="trust-ribbon__card">
              <span className="trust-ribbon__icon" aria-hidden>
                {item.icon}
              </span>
              <span className="trust-ribbon__copy">
                <span className="trust-ribbon__label">{t[item.labelKey]}</span>
                <span className="trust-ribbon__sub">{t[item.subKey]}</span>
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
